var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('viewsource-link',{attrs:{"to":"/","types":['underlined']}},[_vm._v("Back to the homepage")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }